// TODO - Improve/add/use these styles
export const TextSize = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  body: "body",
  bodySmall: "bodySmall"
} as const;

export type TextSizeType = keyof typeof TextSize;

export type TextStyleType = Record<TextSizeType, string>;

export const TEXT_STYLES: TextStyleType = {
  h1: "font-bold text-xl",
  h2: "font-semibold text-lg",
  h3: "font-bold text-xs uppercase tracking-wide-5",
  h4: "text-sm font-medium",
  body: "text-sm",
  bodySmall: "text-xs"
};

export const HOVER_STYLES =
  "hover:bg-cyan-50/50 hover:border-cyan-600/30 focus:bg-cyan-50  focus:outline-cyan-600 transition-colors";
